export default __webpack_public_path__ + "static/media/checkbox-checked.d4b7a897.svg";